import { z } from "zod";
export const TEAM_CONTEXT_ROLES = ["owner", "member"];
export const teamContextRoleSchema = z.enum(TEAM_CONTEXT_ROLES);
export const TeamContextRoleEnum = {
    OWNER: "owner",
    MEMBER: "member",
};
